import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import { LazyDiv } from 'components/common/LazyHtml'
import { H1 } from 'components/common/Text/Text'

const BOTTrailerTiresTeaser = ({ content, title }) =>
  <Content>
    <Title headline_narrow data-at-heading="trailer-teaser">{ title }</Title>
    <LazyDiv data-html-block content={ content } />
  </Content>

BOTTrailerTiresTeaser.type = 'BOTTrailerTiresTeaser'

export default BOTTrailerTiresTeaser

BOTTrailerTiresTeaser.propTypes = {
  content: PropTypes.string,
  title: PropTypes.string
}

const Content = styled.div`
  margin: 0 auto;
  ${Media.desktop`
    margin-top: 51px;
  `}
`

const Title = styled(H1)`
  text-transform: uppercase;
  ${Mixin.responsive('margin', '10px 0 34px', '3px 0 13px 16px')}
  ${Mixin.font.GothamBold(34)}
  ${Media.mobile`
    ${Mixin.font.GothamBold(14)}
  `}
`
